<template>
  <div class="flex flex-col justify-center items-center h-full w-full opacity-40 pt-8">
    <img
      class="w-1/3"
      src="@/assets/converza_icon_only.svg"
    >
    <span>Ainda não existem sessões</span>
  </div>
</template>